import { render, staticRenderFns } from "./AnimalNumbersLifestyleOther.vue?vue&type=template&id=b50a486a&"
import script from "./AnimalNumbersLifestyleOther.vue?vue&type=script&lang=js&"
export * from "./AnimalNumbersLifestyleOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports